import { print } from 'graphql/language/printer';

const createBrowserClient = (providedFetch, { storefrontDomain, storefrontToken, storefrontAPIVersion }) => {
    // CONFIG
    const _apiHost = `https://${storefrontDomain}/api/${storefrontAPIVersion}/graphql.json`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
        }
    };

    // Methods
    const query = async ({ query: AST, variables = {} }) => {
        const q = AST ? print(AST) : {}; // AST to String
        const body = JSON.stringify({ query: q, variables });
        return providedFetch(_apiHost, { ...options, body }).then((r) => r.json());
    };

    const mutate = async ({ mutation: AST, variables = {} }) => {
        const mutation = AST ? print(AST) : {}; // AST Mutation to String
        const body = JSON.stringify({ query: mutation, variables });
        return providedFetch(_apiHost, { ...options, body }).then((r) => r.json());
    };

    return { query, mutate };
};

export default createBrowserClient;
